var map = {
	"./angle down.svg": 85993,
	"./angle left double.svg": 5949,
	"./angle left.svg": 30578,
	"./angle right double.svg": 30284,
	"./angle right.svg": 76553,
	"./angle up.svg": 63046,
	"./arrow down.svg": 80259,
	"./arrow left.svg": 4308,
	"./arrow right.svg": 65851,
	"./arrow up.svg": 98332,
	"./asterix.svg": 35628,
	"./bookmark filled.svg": 40746,
	"./bookmark.svg": 72610,
	"./calendar.svg": 62912,
	"./check.svg": 63882,
	"./circle check.svg": 85326,
	"./circle cross.svg": 61102,
	"./circle info.svg": 45478,
	"./circle minus.svg": 79594,
	"./circle plus.svg": 27202,
	"./circle question.svg": 81222,
	"./copy.svg": 75313,
	"./cross.svg": 72650,
	"./document.svg": 40769,
	"./download.svg": 80034,
	"./edit.svg": 26110,
	"./email.svg": 75750,
	"./eye open.svg": 73011,
	"./filter.svg": 63672,
	"./irrelevant.svg": 48328,
	"./link.svg": 67826,
	"./list.svg": 18598,
	"./lock.svg": 15731,
	"./menu.svg": 19211,
	"./minus.svg": 53782,
	"./north east.svg": 20018,
	"./plus.svg": 92958,
	"./printer.svg": 414,
	"./question.svg": 80730,
	"./search.svg": 85418,
	"./speech bubble filled.svg": 44502,
	"./speech bubble.svg": 75566,
	"./spinner.svg": 53045,
	"./text document.svg": 35550,
	"./trash.svg": 81220,
	"./unlock.svg": 92278,
	"./warning.svg": 12686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 935;